"use strict";

var _classCallCheck = require("/root/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/workspace/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/workspace/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/workspace/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/workspace/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_state_1 = require("prosemirror-state");

var prosemirror_commands_1 = require("prosemirror-commands");

var Extension_1 = __importDefault(require("../lib/Extension"));

var isUrl_1 = __importDefault(require("../lib/isUrl"));

var isInCode_1 = __importDefault(require("../queries/isInCode"));

var MarkdownPaste = /*#__PURE__*/function (_Extension_1$default) {
  _inherits(MarkdownPaste, _Extension_1$default);

  var _super = _createSuper(MarkdownPaste);

  function MarkdownPaste() {
    _classCallCheck(this, MarkdownPaste);

    return _super.apply(this, arguments);
  }

  _createClass(MarkdownPaste, [{
    key: "name",
    get: function get() {
      return "markdown-paste";
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this = this;

      return [new prosemirror_state_1.Plugin({
        props: {
          handlePaste: function handlePaste(view, event) {
            if (view.props.editable && !view.props.editable(view.state)) {
              return false;
            }

            if (!event.clipboardData) return false;
            var text = event.clipboardData.getData("text/plain");
            var html = event.clipboardData.getData("text/html");
            var state = view.state,
                dispatch = view.dispatch;

            if (isUrl_1.default(text)) {
              if (!state.selection.empty) {
                prosemirror_commands_1.toggleMark(_this.editor.schema.marks.link, {
                  href: text
                })(state, dispatch);
                return true;
              }

              var embeds = _this.editor.props.embeds;

              if (embeds) {
                var _iterator = _createForOfIteratorHelper(embeds),
                    _step;

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var embed = _step.value;
                    var matches = embed.matcher(text);

                    if (matches) {
                      _this.editor.commands.embed({
                        href: text,
                        component: embed.component,
                        matches: matches
                      });

                      return true;
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }

              var _transaction = view.state.tr.insertText(text, state.selection.from, state.selection.to).addMark(state.selection.from, state.selection.to + text.length, state.schema.marks.link.create({
                href: text
              }));

              view.dispatch(_transaction);
              return true;
            }

            if (text.length === 0 || html) return false;
            event.preventDefault();

            if (isInCode_1.default(view.state)) {
              view.dispatch(view.state.tr.insertText(text));
              return true;
            }

            var paste = _this.editor.parser.parse(text);

            var slice = paste.slice(0);
            var transaction = view.state.tr.replaceSelection(slice);
            view.dispatch(transaction);
            return true;
          }
        }
      })];
    }
  }]);

  return MarkdownPaste;
}(Extension_1.default);

exports.default = MarkdownPaste;